var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"align-items":"center","margin-right":"auto","margin-left":"auto"}},[_c('b-container',_vm._l((_vm.contactModelList),function(contactModelItem){return _c('div',{key:contactModelItem.contactId},[_c('usersTableRow',{attrs:{"contactModel":contactModelItem,"availableGroups":_vm.availableGroups,"isAdmin":_vm.isAdmin},on:{"contactUpdated":_vm.getContactList}})],1)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-157fa75c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/templates/users.html
// module id = null
// module chunks = 